// Controlla se un valore è vuoto
export function isEmptyValue(value: unknown): boolean {
    return (
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0)
    );
}

// Controlla se contiene "/"
export function containsForbiddenChar(value: string | undefined): boolean {
    const forbiddenChar = "/";
    if (!value) return false;
    return value.includes(forbiddenChar);
}

// date
// Controlla se una data è precedente o uguale a un'altra
export function isDateBeforeOrEqual(dateA: string | undefined, dateB: string | undefined): boolean {
    if (!dateA || !dateB) return false;
    return new Date(dateA).getTime() <= new Date(dateB).getTime();
}

// Controlla se un anno è compreso in un intervallo
// Default: 2000-2100
export function isYearInRange(date: string | undefined, min = 2000, max = 2100): boolean {
    if (!date) return false;
    const year = new Date(date).getFullYear();
    return year >= min && year <= max;
}
